module.exports = __webpack_public_path__ + "img/04.feae0a22.svg";